export const capitalise = (word: string) => {
    if (!word) return '';

    const trimmed = word.trim();
    if (!trimmed) return '';

    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};
